import React, { useContext, useEffect, useState } from 'react';
import { TasksContext } from '../../store';
import { MapperService } from '../../services/mapper/mapper.service';
import { TasksService } from '../../services/tasks/tasks.service';
import { CalendarMobComponent } from '../calendar-mob/calendar-mob.component';
import { TasksListMobComponent } from '../tasks-list-mob/tasks-list-mob.component';
import moment from "moment";
import "moment/locale/de";
export default function TasksCalendarMob(props: any) {
  const {setBuilding, activeFilters, setFilters} = useContext(TasksContext);
  const emptyObj: any = {};
  const { buildingId } = props;
  const [tasks, setTasks] = useState(emptyObj);
  const [selectedDate, setDate] = useState(moment().format("YYYY-MM-DD"));
  const [fromDate, setFromDate] = useState(moment().startOf('month').format("YYYY-MM-DD"));
  const [toDate, setToDate] = useState(moment().endOf('month').format("YYYY-MM-DD"));
  const mapperService = new MapperService();
  const tasksService = new TasksService();
  const [loading, setLoading] = useState(true);

  async function getLogs() {
    setLoading(true);
    const buildingWithTasks = await tasksService.listTasksByBuildingId(buildingId, fromDate, toDate);
    const { name, employees } = buildingWithTasks;
    const { allTasks, filters } = await mapperService.mobTasks(employees, activeFilters);
    setFilters(filters);
    setBuilding(name);
    setTasks(allTasks);
    setLoading(false);
  }

  const handleDateChange = (date: string) => {
    setDate(date);
  }

  // uncomment when api done with dates
  const handleMonthChange = (date: any) => {
    const from = date.format("YYYY-MM-DD");
    const to = date.endOf("month").format("YYYY-MM-DD")
    setFromDate(from);
    setToDate(to);
  }

  useEffect(() => {
    getLogs();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    getLogs();
    // eslint-disable-next-line
  }, [activeFilters, fromDate, toDate]);

  return (
    <>
      <CalendarMobComponent
        data={tasks}
        refresh={getLogs}
        onDateChange={handleDateChange}
        onMonthChange={handleMonthChange}
      />
      <TasksListMobComponent 
        data={tasks[selectedDate]}
        activeFilters={activeFilters}
        buildingId={buildingId}
        loading={loading}
      />
    </>
  );
}
